import { Organizable } from './Organizable';

const computeHorizontal = <T extends Iterable<Organizable>>(plots: T, spacing = 20): T => {
    let xa = 0;
    for (const p of plots) {
        p.moveTo(xa, 0);
        xa += p.width() + spacing;
    }
    return plots;
};

const computeVertical = <T extends Iterable<Organizable>>(plots: T, spacing = 20): T => {
    let ya = 0;
    for (const p of plots) {
        p.moveTo(0, ya);
        ya += p.height() + spacing;
    }
    return plots;
};

export const LineLayout = { computeHorizontal, computeVertical };
